import { inject, Injectable, signal } from '@angular/core';
import { Platform } from '@ionic/angular';


@Injectable({ providedIn: 'root' })
export class PwaInstallService {
  private platform = inject(Platform);

  readonly canInstallAndroid = signal(false);
  readonly showInstallIos = signal(false);
  readonly isInstalled = signal(false);
  private _deferredInstallPrompt: any = null;
  private dismissedInstall = false;
  init() {
    // Check if already installed
    if (window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone) {
      this.isInstalled.set(true);
      return;
    }
    if (this.platform.is('ios')) {
      this.showInstallIos.set(true);
    } else {
        window.addEventListener('beforeinstallprompt', (e) => {
            this._deferredInstallPrompt = e;
            if (this.dismissedInstall) {
              return;
            }
            this.canInstallAndroid.set(true);
        });
    
        window.addEventListener('appinstalled', () => {
            this.canInstallAndroid.set(false);
            this.isInstalled.set(true);
        });
    }
  }

  async requestInstall() {
    if (this.platform.is('ios')) {
      this.showInstallIos.set(true);
      return;
    } else {
      if (!this._deferredInstallPrompt) return null;
      this._deferredInstallPrompt.prompt();
      const result = await this._deferredInstallPrompt.userChoice;
      this._deferredInstallPrompt = null;
      this.dismissedInstall = result.outcome === 'dismissed';
      this.canInstallAndroid.set(false);
      this.isInstalled.set(result.outcome === 'accepted');
    }
  }
}